import { api } from './client'

export interface TeaType {
    id: string
    name: string
    code: string
    is_active: boolean
    /** Chọn sẵn khi tạo phiếu cân chè tươi; tối đa một giống. */
    is_default: boolean
    created_at: string
    updated_at: string
}

// code is server-generated ("TTNN") and immutable; the client never sends it.
export interface UpsertTeaTypeRequest {
    name: string
    is_active: boolean
    /** Bật cho giống này thì server bỏ cờ ở giống đang mặc định. */
    is_default: boolean
}

export interface ListTeaTypesParams {
    search?: string
    is_active?: boolean
    page?: number
    per_page?: number
}

export const teaTypesApi = {
    list: (params?: ListTeaTypesParams) =>
        api.get<TeaType[]>('/tea-types', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    getById: (id: string) => api.get<TeaType>(`/tea-types/${id}`),
    create: (data: UpsertTeaTypeRequest) =>
        api.post<TeaType>('/tea-types', data),
    update: (id: string, data: UpsertTeaTypeRequest) =>
        api.put<TeaType>(`/tea-types/${id}`, data),
    delete: (id: string) => api.delete(`/tea-types/${id}`),
}
